import { useState, useEffect } from "react";
import axios from "axios";
import { storage } from "../utils/storage";
import { TierName } from "../types/AIModel";

const baseUrl = process.env.REACT_APP_API_CONFIG;

export interface UserProfile {
  // Usage stats - remaining
  conversationsRemaining?: number | string;
  chatMessagesRemaining?: number | string;
  // Usage stats - used & limits (for X/Y display)
  conversationsUsed?: number;
  conversationsLimit?: number | string;
  chatMessagesUsed?: number;
  chatMessagesLimit?: number | string;
  // Subscription
  subscriptionActive?: boolean;
  subscriptionStatus?: "active" | "inactive" | "canceled" | "expired";
  tier?: TierName;
}

export default function useUser() {
  const [userProfile, setUserProfile] = useState<UserProfile | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [userEmail, setUserEmail] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserProfile = async () => {
      const token = storage.getJwtToken();
      const email = storage.getUserEmail();

      if (!token) {
        setError("No authentication token found");
        setLoading(false);
        return;
      }

      setUserEmail(email);

      try {
        const response = await axios.get<UserProfile>(`${baseUrl}/users/me`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUserProfile(response.data);
      } catch (err) {
        setError("Failed to fetch user profile");
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, []);

  return { userProfile, userEmail, loading, error };
}
